import AsoHeader from "../../../components/Aso/Header";
import AsoValidarIdentidadeEmpresa from "../../../components/Aso/Register/AsoValidarIdentidadeEmpresa";

const AsoRegistroValidarIdentidadeEmpresa = () => {
    return(
        <>
            <AsoHeader />
            <AsoValidarIdentidadeEmpresa />
        </>
    );
}

export default AsoRegistroValidarIdentidadeEmpresa;